module.exports = __webpack_public_path__ + "fonts/D-DIN.93a9f667.ttf";